<script setup lang="ts">
import { computed } from 'vue'

const items = computed(() => [
  {
    label: 'Solutions',
    children: [{
      label: 'Cron Jobs',
      icon: 'i-lucide-clock',
      description: 'Schedule and monitor cron jobs with confidence.',
      badge: 'New',
      to: '/cron-jobs'
    }, {
      label: 'Scheduled Tasks',
      icon: 'i-lucide-calendar',
      description: 'Monitor scheduled tasks with confidence.',
      to: '/scheduled-tasks',
      badge: 'Coming soon',
      disabled: true
    }]
  },
  {
    label: 'Pricing',
    to: '/pricing'
  }])
</script>

<template>
  <UHeader>
    <template #left>
      <NuxtLink
        class="w-auto h-6 shrink-0"
        to="/"
      >
        <span class="text-2xl font-bold">Cronr.app <UBadge
          label="beta"
          variant="subtle"
          class="text-sm mb-0.5"
        /></span>
      </NuxtLink>
    </template>

    <UNavigationMenu
      :items="items"
      variant="pill"
      content-orientation="vertical"
    />

    <template #right>
      <UColorModeButton />
      <UButton
        label="Sign in"
        color="neutral"
        variant="ghost"
        to="/login"
      />
      <UButton
        label="Sign up"
        color="neutral"
        trailing-icon="i-lucide-arrow-right"
        class="hidden lg:flex"
        to="/signup"
      />
    </template>

    <template #body>
      <UNavigationMenu
        :items="items"
        orientation="vertical"
        class="-mx-2.5"
      />

      <USeparator class="my-6" />

      <UButton
        label="Sign in"
        color="neutral"
        variant="subtle"
        to="/login"
        block
        class="mb-3"
      />
      <UButton
        label="Sign up"
        color="neutral"
        to="/signup"
        block
      />
    </template>
  </UHeader>
</template>
